import styled, { css } from 'styled-components';
import { Modal as AntModal } from 'antd';

import { buttonStyle } from 'ui/components/Buttons';

import { BORDER_RADIUS, PADDING } from './constants';

import { colors } from '@10d/tend-ui-tokens/samolet';

import { IModalProps } from './types';

export const antModalContentStyle = css`
  border-radius: ${BORDER_RADIUS} ${BORDER_RADIUS} 0 0;
  padding: 0 0 ${BORDER_RADIUS} 0;
`;

export const StyledModal = styled(AntModal)<IModalProps>`
  ${buttonStyle}

  .ant-modal-close {
    top: 24px;
    right: 24px;

    & :hover {
      background-color: transparent;
    }

    & .ant-modal-close-x {
      color: ${colors.gray900};
      margin-top: 4px;
      font-size: 24px;

      & .anticon {
        border-radius: 50%;
        &:hover {
          background-color: #f7f9fe;
        }

        & svg {
          height: 24px;
          width: 24px;
        }
      }
    }

    & .ant-modal-close-x:hover {
      & .anticon {
        background-color: #f7f9fe;
      }
    }
  }

  & .ant-modal-content {
    border-radius: ${BORDER_RADIUS};
    box-shadow:
      0 8px 22px -6px #18274b0a,
      0px 14px 64px -4px #18274b0a;
    padding: 20px 24px;

    & .ant-modal-header {
      border-radius: ${BORDER_RADIUS} ${BORDER_RADIUS} 0 0;
      padding: 4px 0;
      border-bottom: 1px solid #f0f0f0;

      & .ant-modal-title {
        color: ${colors.gray900};
        line-height: 24px;
        font-weight: 700;
        padding-right: 40px;
      }
    }

    & .ant-modal-footer {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0 0 ${BORDER_RADIUS} ${BORDER_RADIUS};
      padding: ${PADDING} 0px 2px 0px;
      margin: 0 ${PADDING};
    }
  }
`;
